import { Expose } from 'class-transformer';

class UnityUserStatus {
    @Expose()
    accountNumber: string;

    @Expose()
    loginStatus: string;

    @Expose()
    unityTier: string;

    @Expose()
    tierCreditsForNextTier: number;
}

class UnityUserSummary {
    @Expose()
    accountNumber: string;

    @Expose()
    emailAddress: string;

    @Expose()
    firstName: string;

    @Expose()
    lastName: string;

    @Expose()
    totalTierCredits: number;

    @Expose()
    totalUnityPoints: number;
}

export class ModelUnityUser {
    @Expose()
    status: UnityUserStatus;

    @Expose()
    summary: UnityUserSummary;

    @Expose()
    unityPointIsActive: boolean;
}
